import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import loadable from '@loadable/component';

const CreatePackPage = loadable(() => import('../containers/quikreasy/CreatePack'));
const CoworkingSpacePage = loadable(() => import('../containers/coworkingspace'));
const RenewPackPage = loadable(() => import('../containers/quikreasy/RenewPack'));
const Homelane = loadable(() => import('../containers/homelane'));
const Niro = loadable(() => import('../containers/niro'));
const Cars24 = loadable(() => import('../containers/cars24'));
const InstantHire = loadable(() => import('../containers/instantHire'));
const JobsBulkAd = loadable(() => import('../containers/jobsBulkAd'));
const MoneyView = loadable(() => import('../containers/moneyview'));
const VIPLanding = loadable(() => import('../containers/viplanding'));
const PersonalLoan = loadable(() => import('../containers/personalLoan'));

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/promo/quikreasy/create-your-pack" component={CreatePackPage} />
      <Route exact path="/promo/quikreasy/renew-your-pack" component={RenewPackPage} />
      <Route exact path="/promo/coworkingspace" component={CoworkingSpacePage} />
      <Route exact path="/promo/homelane" component={Homelane} />
      <Route exact path="/promo/personal-loan" component={PersonalLoan} />
      <Route exact path="/promo/niro" component={Niro} />
      <Route exact path="/partner/leads" component={Cars24} />
      <Route exact path="/promo/jobs/instant-hire" component={InstantHire} />
      <Route exact path="/promo/jobs/bulkad" component={JobsBulkAd} />
      <Route exact path="/promo/moneyview/:token" component={MoneyView} />
      <Route exact path="/jobs/vip-landing" component={VIPLanding} />
      <Route render={() => <Redirect to="/404Error" />} />
    </Switch>
  );
};

export default Routes;
